
<!-- (isInViewport)="onIsInViewport($event)" -->
<section class="balance">
<div class="grid grid-cols-2" isInVewport (isInViewport)="onViewportChange('charts',$event)" [threshold]="0.3">
    <ng-container > 
        <div [@fadeInUp]="{value: visibilityState['charts'], params: {delay: '500ms'} }">
            <ngx-dashboard-card *ngIf="fatturatoChart" [cardContainerConfig]="fatturatoChart.cardContainerConfig"
                [graphic]="fatturatoChart.graphic">
            </ngx-dashboard-card>
        </div>   
        <div [@fadeInUp]="{value: visibilityState['charts'], params: {delay: '700ms'} }">
            <ngx-dashboard-card *ngIf="profitsChart" [cardContainerConfig]="profitsChart.cardContainerConfig"
                [graphic]="profitsChart.graphic">
             </ngx-dashboard-card>
        </div>
    </ng-container>
</div>
<div class="grid grid-cols-3 financial-metrix gap-16" *ngIf="showFinancialMatrix" isInVewport (isInViewport)="onViewportChange('metrix',$event)" [threshold]="0.3">
    <ng-container *ngFor="let metrix of financialMetrix, let i = index">
         <div [@fadeInUp]="{value: visibilityState['metrix'], params: {delay: ((i * 100) + 500) + 'ms'} }">
            <ngx-card [title]="metrix.title | translate" [icon]="metrix.icon" [bgcolor]="'white'" [contentClass]="'p--0'" [cardClass]="' icon-end p--8'">
                <!-- <span class="rating-icon" [ngClass]="metrix.rating"></span> -->
                <div class="chart-indicator p--16">
                    <ngx-indicator [indicator]="metrix.value"></ngx-indicator>
                </div>
            </ngx-card>
        </div>
    </ng-container>
</div>
</section>